import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

const columnUnits: ColumnUnits[] = [
  {columnId: 'observationsRa', units: 'h:m:s'},
  {columnId: 'observationsDec', units: 'd:m:s'},
  {columnId: 'observationsBaselineL80', units: 'm'},
  {columnId: 'observationsBaselineL5', units: 'm'},
  {columnId: 'observationsIntegration', units: 's'},
  {columnId: 'observationsVelocityResolution', units: 'km/s'},
  {columnId: 'observationsFrequencyResolution', units: 'kHz'},
  {columnId: 'observationsPwv', units: 'mm'},
  {columnId: 'observationsFov', units: 'arcsec'},
  {columnId: 'observationsLargestAngularScale', units: 'arcsec'},
  {columnId: 'observationsSpatialResolution', units: 'arcsec'},
  {columnId: 'observationsContinuumSensitivity', units: 'mJy/beam'},
  {columnId: 'observationsLineSensitivity', units: 'mJy/beam'}
];

export type Units = 'h:m:s' | 'd:m:s'
  | 'h' | 'm' | 's'
  | 'GHz' | 'MHz' | 'kHz'
  | 'km/s' | 'm/s' | 'km'
  | 'deg' | 'arcmin' | 'arcsec' | 'miliarsec'
  | 'cm' | 'um' | 'nm' | 'a' | 'mm'
  | 'mJy/beam' | 'Jy/beam' | '&mu;Jy/beam';


export interface ColumnUnits {
  readonly columnId: string;
  readonly units: Units;
}

@Injectable({
  providedIn: 'root'
})
export class UnitsFormattersService {
  private columnsUnitsSubject = new BehaviorSubject<ColumnUnits[]>(columnUnits);

  getColumnsUnits(): Observable<ColumnUnits[]> {
    return this.columnsUnitsSubject.asObservable();
  }

  setColumnsUnits(columnUnit: ColumnUnits): void {
    if (columnUnit.columnId === 'observationsRa' || columnUnit.columnId === 'observationsDec') {
      this.handleRaDecUnitsChanged(columnUnit);
    } else {
      const columnsUnitsValue = this.columnsUnitsSubject.getValue().filter(colUnits => colUnits.columnId !== columnUnit.columnId);
      this.columnsUnitsSubject.next([...columnsUnitsValue, columnUnit]);
    }
  }

  private handleRaDecUnitsChanged(columnUnit: ColumnUnits): void {
    const units = this.columnsUnitsSubject.getValue().filter(cu => cu.columnId !== 'observationsRa' && cu.columnId !== 'observationsDec');

    this.columnsUnitsSubject.next([
      ...units,
      {columnId: 'observationsRa', units: columnUnit.units === 'deg' ? 'deg' : 'h:m:s'},
      {columnId: 'observationsDec', units: columnUnit.units === 'deg' ? 'deg' : 'd:m:s'}
    ]);
  }
}
